import { createContext, useContext } from 'react';
export const ConsentCtx = createContext(null);
export const useConsent = () => {
    const ctx = useContext(ConsentCtx);
    if (!ctx)
        throw new Error('ConsentProvider missing');
    return ctx;
};
//# sourceMappingURL=ConsentContext.js.map